// eslint-disable-next-line import/no-extraneous-dependencies
import { ObjectId } from 'bson'

import { slugifyString } from '@campai/lib-common/utils/misc'

// TODO: import from lib-common when merged to dev
const isObjectId = (objectId: string) => {
    return ObjectId.isValid(objectId)
}

export const normalizePlausiblePathname = (pathname: string, organizationName: string) => {
    const [appKeyOrShortId, ...pathParts] = pathname
        .split('/')
        .filter(Boolean)
        .map((p) => (isObjectId(p) ? ':id' : p))

    const isRootApp = appKeyOrShortId.length !== 2

    const organizationIdentifier = slugifyString(organizationName).toLocaleLowerCase()

    const urlParts = [organizationIdentifier, ...pathParts]

    if (!isRootApp) {
        urlParts.splice(1, 1)
    }

    const appIdentifier = isRootApp ? 'root' : appKeyOrShortId

    return [appIdentifier, ...urlParts].join('/')
}
